export function VideochatIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.836 9.083c-.368-.23-.836.046-.836.49v4.853c0 .445.468.72.836.492l3.896-2.427a.585.585 0 000-.982l-3.896-2.426z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 1.536-.405 2.97-1 4.23V21h-4.636c-1.32.64-2.801 1-4.364 1-5.523 0-10-4.477-10-10zm10-8a8 8 0 103.668 15.112l.216-.112H19v-3.235l.105-.21C19.65 14.455 20 13.25 20 12a8 8 0 00-8-8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
